(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('PaginationService', [PaginationService]);

    function PaginationService() {
        function getLinks(searchResult, sz) {
            var total = +searchResult.getNumFound();
            var startRow = +searchResult.getStartRow();
            var pageSize = +sz;

            var lastPage = Math.floor((total - 1) / pageSize); // zero - based
            var currentPage = Math.floor(startRow / pageSize); // zero - based

            var links = [];

            if (currentPage > 0) {
                links.push({"display": "<<", "target": 0});
                links.push({"display": "<", "target": (currentPage - 1) * pageSize});
            }

            var len = 5;
            var min;
            if (len > lastPage + 1) {
                min = 0;
                len = lastPage + 1;
            }
            else {
                var middle = Math.floor(len / 2); // zero - based
                min = currentPage - middle;
                if (min < 0) min = 0;
                if (min + len > lastPage + 1) {
                    min = lastPage + 1 - len;
                }
            }
            for (var display = min; display < min + len; display++) {
                links.push({
                    "display": (display + 1) + "",
                    "target": display * pageSize,
                    "current": (display === currentPage)
                });
            }

            if (currentPage < lastPage) {
                links.push({"display": ">", "target": (currentPage + 1) * pageSize});
                links.push({"display": ">>", "target": lastPage * pageSize});
            }
            return links;
        }

        return {"getLinks": getLinks};
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/PaginationService.js